export default __webpack_public_path__ + "static/media/raki_detail2.db310c43.jpg";